module.exports = __webpack_public_path__ + "img/packages/l4.4589d7.png";